import $ from 'jquery';

export default function formValidation() {
  const validationHighlight = (element) => {
    $(element).siblings('label').find('.asterisk').addClass('txt-prim');
  };

  const validationUnhighlight = (element) => {
    $(element).siblings('label').find('.asterisk').removeClass('txt-prim');
  };

  $('form').each(function () {
    const $form = $(this);

    if ( $(this).hasClass('js-inquire-form') ) {
      $form.validate({
        rules: {
          Email: {
            required: function () {
              return $form.find('.js-contact-email').is(':checked') || $('#contact-email-kite').is(':checked');
            },
          },
          Address: {
            required: function () {
              return $form.find('.js-contact-mail').is(':checked') || $('#contact-mail-kite').is(':checked');
            },
          },
          City: {
            required: function () {
              return $form.find('.js-contact-mail').is(':checked') || $('#contact-mail-kite').is(':checked');
            },
          },
          State: {
            required: function () {
              return $form.find('.js-contact-mail').is(':checked') || $('#contact-mail-kite').is(':checked');
            },
          },
          Zip: {
            required: function () {
              return $form.find('.js-contact-mail').is(':checked') || $('#contact-mail-kite').is(':checked');
            },
          },
          Phone: {
            required: function () {
              return $form.find('.js-contact-phone').is(':checked') || $('#contact-phone-kite').is(':checked');
            },
          },
          FirstName: {
            required: true,
          },
          LastName: {
            required: true,
          },
          Product: {
            required: true,
          },
          HCPType: {
            required: function () {
              return $form.find('.js-contact-type-hcp').is(':checked') || $('#prof-info-hcp').is(':checked');
            },
          },
          Question1: {
            required: true,
          },
          Question2: {
            required: true,
          },
          Question3: {
            required: true,
          },
          Question4: {
            required: true,
          },
        },
        highlight: function (element) {
          validationHighlight(element);
        },
        unhighlight: function (element) {
          validationUnhighlight(element);
        },
      });
    } else if ($(this).hasClass('js-meeting-form')) {
      $(this).validate({
        rules: {
          FirstName: {
            required: true,
          },
          LastName: {
            required: true,
          },
          Email: {
            required: true,
          },
          InstitutionZip: {
            required: true,
          },
          Company: {
            required: true,
          },
          Product: {
            required: true,
          },
          UserQuestion: {
            required: true,
          },
        },
        highlight: function (element) {
          validationHighlight(element);
        },
        unhighlight: function (element) {
          validationUnhighlight(element);
        },
      });
    } else if ($(this).hasClass('js-search-form')) {
      $(this).validate({
        rules: {
          Product: {
            required: true,
          },
          query: {
            required: true,
            minlength: 2,
            maxlength: 30,
          },
          'doc-types[]': {
            required: true,
          },
        },
        highlight: function (element) {
          validationHighlight(element);
        },
        unhighlight: function (element) {
          validationUnhighlight(element);
        },
      });
    } else if ($(this).hasClass('js-global-inquire-form')) {
      $(this).validate({
        rules: {
          Email: {
            required: '#contact-email-kite:checked'
          },
          Address: {
            required: '#contact-mail-kite:checked'
          },
          City: {
            required: '#contact-mail-kite:checked'
          },
          State: {
            required: '#contact-mail-kite:checked'
          },
          Zip: {
            required: '#contact-mail-kite:checked'
          },
          Phone: {
            required: '#contact-phone-kite:checked',
            number: $('html').hasClass('lang-ja'),
            minlength: 10,
          },
          FirstName: {
            required: true
          },
          LastName: {
            required: true
          },
          Company: {
            required: $('html').hasClass('lang-ja'),
          },
          Product: {
            required: true
          },
          HCPType: {
            required: '#prof-info-hcp:checked'
          },
          Country: {
            required: true
          },
          ContactCountry: {
            required: true
          },
          Question1: {
            required: true
          },
          Question2: {
            required: true
          },
          Question3: {
            required: true
          },
          Question4: {
            required: true
          },
          ConferenceInfo: {
            required: true
          },
          Degree: {
            required: '#prof-info-hcp:checked'
          },
          GileadRepEmail: {
            email: true,
            gileadEmail: true,
          }
        }
      });
    } else {
      $(this).validate({
        highlight: function (element) {
          validationHighlight(element);
        },
        unhighlight: function (element) {
          validationUnhighlight(element);
        },
      });
    }
  });

  $.extend($.validator.messages, {
    required: 'field required',
    gileadEmail: 'Email must end with @gilead.com',
  });

  $.validator.addMethod('gileadEmail', function(value, element) {
    return this.optional(element) || /^.+@gilead\.com$/.test(value);
  }, 'Email must end with @gilead.com');
}



// WEBPACK FOOTER //
// ./src/assets/js/project/form-validation.js